/* ==========================================================================
   SPICY HOME - MEDIA WALL, HOTSPOTS
   Click a dot, its label tags onto the image; click again or open another to
   close it. Progressive enhancement: with this file missing every label is
   simply shown (see the section stylesheet's html:not(.sh-js) rule), so the
   detail is never lost - the dots just stop being interactive.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (root.__mwBooted) return;
    root.__mwBooted = true;

    var spots = Array.prototype.slice.call(root.querySelectorAll('[data-mw-spot]'));
    if (!spots.length) return;

    function closeAll(except) {
      spots.forEach(function (s) {
        if (s === except) return;
        s.classList.remove('is-open');
        var b = s.querySelector('[data-mw-dot]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    spots.forEach(function (spot) {
      var dot = spot.querySelector('[data-mw-dot]');
      if (!dot) return;
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        var open = spot.classList.contains('is-open');
        closeAll(spot);
        if (open) {
          spot.classList.remove('is-open');
          dot.setAttribute('aria-expanded', 'false');
        } else {
          spot.classList.add('is-open');
          dot.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // A click anywhere off the dots closes the open label.
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target) || !e.target.closest('[data-mw-spot]')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-mw]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); }, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();